import React, { Component } from 'react';
import AssetForm from './asset-form/AssetForm';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';
import RevisionModal from './RevisionModal';
import { formValueSelector } from 'redux-form';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import AssetDetailLayout from './AssetDetailLayout';

class EditAsset extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.handleNewRevisionSubmit = this.handleNewRevisionSubmit.bind(this);
    this.handleExistingRevisionSubmit = this.handleExistingRevisionSubmit.bind(
      this
    );
  }
  componentDidMount() {
    const {
      match,
      getType,
      clearGetType,
      clearPutAsset,
      clearGetAsset,
      getAsset,
      getAssetSiblings,
      clearGetAssetSiblings
    } = this.props;
    const { params } = match || {};
    const { type, id } = params || {};

    clearGetType();
    clearPutAsset();
    clearGetAsset();
    clearGetAssetSiblings();
    getType(type);
    getAsset({ type, id });
    getAssetSiblings({ type, id });
  }
  submitForm(payload) {
    const { showModal } = this.props;
    showModal('EditRevisionModal');
  }
  handleNewRevisionSubmit({ versionName }) {
    const { match, putAsset, history, formValues } = this.props;

    const payload = Object.assign({}, formValues, {
      versionName,
      newVersion: true
    });

    const { params } = match || {};
    const { type, id } = params || {};
    putAsset({ type, payload, id }, 'asset-form', null, data => {
      const { insertedIds } = data || {};
      history.push(`/pages/${type}/${insertedIds[0]}`);
    });
  }
  handleExistingRevisionSubmit() {
    const { match, putAsset, history, formValues } = this.props;

    const { params } = match || {};
    const { type, id } = params || {};
    putAsset({ type, payload: formValues, id }, 'asset-form', null, data => {
      history.push(`/pages/${type}/${id}`);
    });
  }
  render() {
    const {
      asset,
      data,
      inProgress,
      assetSiblings,
      match,
      history
    } = this.props;
    const { opts } = asset || {};
    const { label } = opts || {};
    if (inProgress) {
      return <div>Loading</div>;
    }

    const { assetType } = asset || {};
    const { _id } = data || {};

    const CancelButton = () => (
      <Link to={`/pages/${assetType}/${_id}`}>
        <Button bsStyle="hollow-info">
          <span className="ti ti-close" /> Cancel
        </Button>
      </Link>
    );
    return (
      <div className="asset-background">
        <AssetDetailLayout
          assetSiblings={assetSiblings}
          asset={asset}
          match={match}
          history={history}
        >
          <RevisionModal
            isEdit
            name="EditRevisionModal"
            onRevisionSubmit={this.handleNewRevisionSubmit}
            handleExistingRevisionSubmit={this.handleExistingRevisionSubmit}
          />
          <AssetForm
            asset={asset}
            initialValues={data}
            onSubmit={this.submitForm}
            CancelButton={CancelButton}
          />
        </AssetDetailLayout>
      </div>
    );
  }
}

const selector = formValueSelector('asset-form');

const mapState = state => {
  const {
    result: asset,
    error: getTypeErr,
    inProgress: getTypeInProgress
  } = state.getType.toJS();
  const {
    result: data,
    error: getAssetErr,
    inProgress: getAssetInProgress
  } = state.getAsset.toJS();

  const {
    result: assetSiblings,
    error: assetSiblingsErr,
    inProgress: getAssetSiblingsInProgress
  } = state.getAssetSiblings.toJS();

  const formValues = {
    data: selector(state, 'data'),
    tags: selector(state, 'tags')
  };

  const error = getTypeErr || getAssetErr;

  const inProgress = getTypeInProgress || getAssetInProgress;

  return {
    inProgress,
    formValues,
    asset,
    data,
    error,
    assetSiblings
  };
};
const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getType: fetchDux.getType.createAction,
      clearGetType: fetchDux.getType.clearAction,
      putAsset: fetchDux.putAsset.createAction,
      clearPutAsset: fetchDux.putAsset.clearAction,
      getAsset: fetchDux.getAsset.createAction,
      clearGetAsset: fetchDux.getAsset.clearAction,
      getAssetSiblings: fetchDux.getAssetSiblings.createAction,
      clearGetAssetSiblings: fetchDux.getAssetSiblings.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(EditAsset);



// WEBPACK FOOTER //
// ./src/components/routes/assets/EditAsset.js